module.exports = __webpack_public_path__ + "static/media/watch.38cab5f6.png";